import Skeleton from "@mui/material/Skeleton"
import Grid from "@mui/material/Grid"
import Divider from "@mui/material/Divider"
import { count, CreateArray, isDefined } from "../../config/helpers";
import CategorySkeletonTiles from "./CategorySkeletonTiles";
import useWindowSize from "@components/_hooks/useWindowSize";



const CategoryPageLoader = ({sons, template_page_settings}) => {
    const {isMobile} = useWindowSize();

    return (
        <>
            {!isMobile && isDefined(sons) && count(sons) > 0 ? (
                <>
                    <Grid className="mb-3" sx={{marginLeft: '0px'}} spacing={1} container>
                        <CreateArray length={count(sons)}>
                            <Grid item>
                                <Skeleton animation="wave" variant="rectangular" width={125} height={45} />
                            </Grid>
                        </CreateArray>
                    </Grid>
                    <Grid spacing={1} className="justify-space-between" container>
                        <Grid className="ml-2" item xs={1.5}>
                            <Skeleton animation="wave" variant="rectangular" height={50} />
                        </Grid>
                        <Grid item xs={1.5}>
                            <Skeleton animation="wave" variant="rectangular" height={50} />
                        </Grid>
                    </Grid>
                    <Divider className="mt-3"/>
                </>

            ): null}
            
            <CategorySkeletonTiles template_page_settings={template_page_settings}/> 

        </>
    )
}

export default CategoryPageLoader